var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import * as React from 'react';
import { ThemeProvider } from './theme-context';
import { useTheme } from '../hooks/use-theme';
export var ReservedWidthContext = React.createContext(0);
export var ReservedWidthProvider = function (_a) {
  var _b;
  var value = _a.value,
    children = _a.children,
    strategy = _a.strategy;
  var existingValue = (_b = React.useContext(ReservedWidthContext)) !== null && _b !== void 0 ? _b : 0;
  var newValue = strategy === 'add' ? value + existingValue : value;
  var theme = useTheme();
  var newTheme = __assign(__assign({}, theme), {
    reservedWidth: newValue
  });
  // add to any existing height reservations if they exist
  return React.createElement(ReservedWidthContext.Provider, {
    value: strategy !== 'replace' ? value + existingValue : value
  }, React.createElement(ThemeProvider, {
    overrides: newTheme
  }, children));
};
export var useReservedWidth = function () {
  return React.useContext(ReservedWidthContext);
};
export var useAvailableWidth = function () {
  if (typeof window !== 'undefined') {
    return window.innerWidth - useReservedWidth();
  }
};